var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.68048L8.90834 15.8147C8.03956 16.6887 6.86124 17.1797 5.6326 17.1797C4.40396 17.1797 3.22564 16.6887 2.35686 15.8147C1.48808 14.9407 1 13.7553 1 12.5193C1 11.2833 1.48808 10.0979 2.35686 9.22389L9.44851 2.08969C10.0277 1.50702 10.8132 1.17969 11.6323 1.17969C12.4514 1.17969 13.237 1.50702 13.8162 2.08969C14.3954 2.67235 14.7207 3.46261 14.7207 4.28662C14.7207 5.11063 14.3954 5.90089 13.8162 6.48355L6.7168 13.6178C6.4272 13.9091 6.03443 14.0728 5.62488 14.0728C5.21534 14.0728 4.82256 13.9091 4.53297 13.6178C4.24338 13.3264 4.08068 12.9313 4.08068 12.5193C4.08068 12.1073 4.24338 11.7122 4.53297 11.4208L11.0845 4.83779",
    stroke: "#4F4F4F",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.9181ad1d4204a165a7a869b34b5b0653.svg";
export { ForwardRef as ReactComponent };